import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { YELLOW_COLOR } from '../styles/colors';
import { TwemojiWrapper } from './twemojiWrapper';
const CONTAINER_CSS = css `
  border: 2px solid ${YELLOW_COLOR};
  border-radius: 10px;
  color: ${YELLOW_COLOR};
  background-color: rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  padding: 10px;
`;
export const WarningMessageContainer = ({ message }) => {
    return (_jsx("div", { css: CONTAINER_CSS, children: _jsx(Typography, { component: 'div', children: _jsxs(TwemojiWrapper, { children: ["\u26A0\uFE0F ", message] }) }) }));
};
